import { THEMES } from 'src/constants';

const extension = {
  ALL: {
    shape: {
      borderRadius: 4,
    },
    typography: {
      fontFamily: '"Rethink Sans Variable", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    palette: {
      background: {
        // paper: '#ff2b36',
      },
      primary: {
        main: '#FF7015',
        dark: '#FE8725', // This will be used for hover states
        contrastText: '#FFFFFF', // Ensure text contrast is white
      },
      // Add specific palette entry for links
      action: {
        active: '#1C7CBA', // This helps with links
        hover: '#FE8725', // Hover state
        selected: '#EB580D', // Pressed/active state
      },
    },
    components: {
      // Add styles for buttons to use the new hover color
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            color: '#FFFFFF !important', // Force white text for contained primary buttons
            '&:hover': {
              backgroundColor: '#FE8725',
              color: '#FFFFFF !important', // Keep white text on hover
            },
            '&:active': {
              backgroundColor: '#EB580D', // Pressed button color
              color: '#FFFFFF !important',
            },
            // For touch devices and accessibility
            '&.Mui-focusVisible': {
              backgroundColor: '#EB580D',
            },
          },
          outlinedPrimary: {
            '&:hover': {
              borderColor: '#FE8725',
              color: '#FE8725',
            },
            '&:active': {
              borderColor: '#EB580D',
              color: '#EB580D',
            },
          },
          textPrimary: {
            '&:hover': {
              backgroundColor: 'rgba(254, 135, 37, 0.04)', // Lighter version of #FE8725 for text buttons
              color: '#FE8725',
            },
            '&:active': {
              backgroundColor: 'rgba(235, 88, 13, 0.12)', // Lighter version of #EB580D for text buttons
              color: '#EB580D',
            },
          },
        },
      },
      // Add global styles including font-face declaration
      MuiCssBaseline: {
        styleOverrides: `
          body {
            font-family: "Rethink Sans Variable", "Roboto", "Helvetica", "Arial", sans-serif;
          }
          
          /* Ensure all links have the correct color (but not buttons) */
          a:not(.MuiButton-root), .MuiLink-root:not(.MuiButton-root) {
            color: #1C7CBA !important;
          }
          
          a:not(.MuiButton-root):hover, .MuiLink-root:not(.MuiButton-root):hover {
            color: #0E5B8F !important;
          }
          
          /* Ensure contained primary buttons have white text */
          .MuiButton-containedPrimary {
            color: #FFFFFF !important;
          }
          
          /* Button pressed/active state */
          .MuiButton-containedPrimary:active {
            background-color: #EB580D !important;
          }
          
          .MuiButton-outlinedPrimary:active {
            color: #EB580D !important;
            border-color: #EB580D !important;
          }
          
          .MuiButton-textPrimary:active {
            color: #EB580D !important;
          }
        `,
      },
      // Override the MUI Link component to use custom colors
      MuiLink: {
        styleOverrides: {
          root: {
            color: '#1C7CBA !important', // Set your custom link color here with !important
            textDecoration: 'none', // Optional: remove underline
            '&:hover': {
              color: '#0E5B8F !important', // Color when hovering (darker blue)
              textDecoration: 'underline', // Optional: add underline on hover
            },
            // Add specific override for "primary" variant of links to ensure they don't use primary color
            '&.MuiLink-colorPrimary': {
              color: '#1C7CBA !important',
              '&:hover': {
                color: '#0E5B8F !important',
              },
            },
          },
        },
      },
      // Add styles for Typography component to ensure links inside Typography have the correct color
      MuiTypography: {
        styleOverrides: {
          root: {
            '& a': {
              color: '#1C7CBA !important',
              textDecoration: 'none',
              '&:hover': {
                color: '#0E5B8F !important',
                textDecoration: 'underline',
              },
            },
            // Ensure all links in typography components use the blue color
            '& .MuiLink-root': {
              color: '#1C7CBA !important',
              '&:hover': {
                color: '#0E5B8F !important',
              },
            },
          },
        },
      },
    },
  },
  [THEMES.LIGHT]: {
  },
  [THEMES.DARK]: {
    shape: {
      borderRadius: 4,
    },
    palette: {
      background: {
        // paper: '#ff36ff',
      },
    },
    components: {
      // Override the MUI Link component for dark mode

    },
  },
};

export default extension;
